import * as client from '../../services/client';
import { TYPES } from 'src/common/constants';
import { PATHS } from 'src/common/constants';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  startPRLoading,
  stopPRLoading,
  startFormLoading,
  stopFormLoading,
} from './loader';

export const saveAssetsDone = (data) => ({
  type: 'SAVE_ASSETS_DONE',
  payload: data,
});

export const fetchAssetsBySuiteId = (id, loader) => (dispatch) => {
  const user = JSON.parse(localStorage.getItem('user'));
  let roleName = user.roles[0].role.name;

  if (loader === false) {
  } else {
    dispatch(startPRLoading());
  }

  return client.getAssetsBySuiteId(id, user.id, roleName).then((response) => {
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        dispatch(stopPRLoading());
        dispatch(saveAssetsDone(responsejson.data));
      });
    } else {
      dispatch(stopPRLoading());
    }
  });
};

const addAssetDone = (payload) => ({
  type: TYPES.ADD_ASSET_DONE,
  payload,
});

const setValidation = (payload) => ({
  type: TYPES.SET_VALIDATION,
  payload,
});

export const clearValidation = () => ({
  type: TYPES.CLEAR_VALIDATION,
});

export const saveAsset = (params) => (dispatch) => {
  dispatch(startFormLoading());
  return client.addAsset(params).then((response) => {
    dispatch(stopFormLoading());
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        if (responsejson.statusCode === 402) {
          toast.error('🚫 Serial Number already exists please try with other', {
            autoClose: 12000,
            position: 'top-center',
          });
          dispatch(
            setValidation('Serial Number already exists please try with other')
          );
        } else if (responsejson.statusCode === 200) {
          toast.success('ⓘ Asset has been added.', {
            autoClose: 10000,
            position: 'top-center',
          });
          dispatch(setValidation('Success'));
          if (params.allRooms && params.allRooms === true) {
            dispatch(fetchAssetsBySuiteId(params.UnitId, false));
          } else {
            dispatch(addAssetDone(responsejson.data));
          }
        } else {
          toast.error(
            '🚫 Something went wrong with adding a asset, please try again.',
            {
              autoClose: 12000,
              position: 'top-center',
            }
          );
        }
      });
    }
  });
};

const updateAssetDone = (payload) => ({
  type: TYPES.UPDATE_ASSET_DONE,
  payload,
});

export const updateAsset = (params, history, suite, property) => (dispatch) => {
  dispatch(startFormLoading());
  return client.updateAsset(params).then((response) => {
    dispatch(stopFormLoading());
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        if (responsejson.statusCode === 402) {
          dispatch(
            setValidation('Serial Number already exists please try with other')
          );
          toast.error(
            ' 🚫 Serial Number already exists please try with other',
            {
              autoClose: 12000,
              position: 'top-center',
            }
          );
        } else {
          toast.success('ⓘ Asset has been updated.', {
            autoClose: 10000,
            position: 'top-center',
          });
          dispatch(setValidation('Success'));
          if (history) {
            history.push({
              pathname: PATHS.SUITES_VIEW.replace(
                ':id',
                property.id + '&' + suite.id
              ),
              state: { suite: suite, property: property },
            });
          }
          dispatch(updateAssetDone(responsejson.data));
        }
      });
    }
  });
};

const deleteAssetDone = (payload) => ({
  type: TYPES.DELETE_ASSET_DONE,
  payload,
});

// Action creator that returns a thunk function for deleting an asset.
export const deleteAsset = (
  areaId,
  assetId,
  history,
  suite,
  property,
  userId
) => {
  // Return a thunk (a function that receives dispatch).
  return async function deleteAssetThunk(dispatch) {
    try {
      dispatch(startFormLoading());

      const response = await client.deleteAsset(assetId, userId);
      const responseJson = await response.json();

      dispatch(stopFormLoading());

      // Handle error case with early return.
      if (!response.ok && response.status !== 200) {
        const errorMessage = responseJson?.message
          ? ` ⓘ ${responseJson.message}`
          : ' ⓘ Asset deleting failed.';

        toast.error(errorMessage, {
          autoClose: 4000,
          position: 'top-center',
        });
        return;
      }

      // Success case.
      if (history) {
        history.push({
          pathname: PATHS.SUITES_VIEW.replace(
            ':id',
            property.id + '&' + suite.id
          ),
          state: { suite, property },
        });
      } else {
        dispatch(deleteAssetDone({ areaId, assetId }));
      }

      toast.success(' ⓘ Asset has been deleted.', {
        autoClose: 4000,
        position: 'top-center',
      });
    } catch (error) {
      dispatch(stopFormLoading());

      toast.error(
        '🚫 Something went wrong with deleting an asset, please try again.',
        {
          autoClose: 4000,
          position: 'top-center',
        }
      );
    }
  };
};

const fetchPropertiesCatalogDone = (payload) => ({
  type: TYPES.FETCH_PROPERTIES_CATALOG_DONE,
  payload: payload,
});

export const clearPropertiesCatalog = () => ({
  type: TYPES.CLEAR_PROPERTIES_CATALOG_DONE,
});

export const fetchPropertyCatalog = (propertyId) => (dispatch) => {
  dispatch(startFormLoading());
  return client
    .fetchPropertyCatalog(propertyId)
    .then((response) => {
      dispatch(stopFormLoading());
      if (response.ok) {
        response.json().then((responsejson) => {
          if (responsejson && responsejson.length > 0) {
            dispatch(fetchPropertiesCatalogDone(responsejson));
          } else {
            dispatch(fetchPropertiesCatalogDone([]));
          }
        });
      } else {
        dispatch(fetchPropertiesCatalogDone([]));
      }
    })
    .catch(() => {
      dispatch(stopFormLoading());
      dispatch(fetchPropertiesCatalogDone([]));
    });
};